import styled from "styled-components";



export const Wrapper = styled.div`
   padding: 120px 0px 150px;
   height: 100%;
`

export const GroupList = styled.ul `

`

export const GroupItem = styled.li `
   max-width: 310px;
   width: 100%;
   padding: 40px 0px;
   background-color: #F1F1F1;
   box-shadow: 0px 4px 4px 0px #00000040;
   border-radius: 20px;
   cursor: pointer;
   transition: 0.3s;
   &:not(:last-child){
      margin-bottom: 80px;
   }
   &:hover{
      background-color: #FFE1A2;
   }
   @media (min-width: 768px){
      width: 300px;
   }
`

export const GroupTitle = styled.p `
   font-family: Raleway;
   font-size: 18px;
   font-weight: 700;
   line-height: 24.2px;

   text-align: center;
`
export const TopWrapper = styled.div`
    display: inline-flex;
   flex-direction: column;
   max-width: 100%;
   min-width: 280px;
    margin-bottom: 40px;
`
export const Button = styled.button`
  background-color: #ffb347; 
  color: white;
  font-family: Raleway, sans-serif;
  font-weight: 700;
  font-size: 12px;
  max-width: 50%;
  padding: 8px 14px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  
  transition:
    background-color 0.3s ease,
    transform 0.2s ease,
    box-shadow 0.3s ease;

  &:hover {
    background-color: #ffa726;
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
  }
`;
